import { getIconToken } from "../fundations/palette/colorTokens";
export const SvgIcon = {
    MuiSvgIcon: {
        defaultProps: {
            fontSize: "medium"
        },
        variants: [
            {
                props: {
                    color: "primary"
                },
                style: ({ theme })=>({
                        color: getIconToken("iconPrimary", theme)
                    })
            },
            {
                props: {
                    color: "secondary"
                },
                style: ({ theme })=>({
                        color: getIconToken("iconSecondary", theme)
                    })
            },
            {
                props: {
                    color: "tertiary"
                },
                style: ({ theme })=>({
                        color: getIconToken("iconTertiary", theme)
                    })
            },
            {
                props: {
                    color: "quarternary"
                },
                style: ({ theme })=>({
                        color: getIconToken("iconQuarternary", theme)
                    })
            }
        ],
        styleOverrides: {
            fontSizeSmall: {
                fontSize: "16px"
            },
            fontSizeMedium: {
                fontSize: "20px"
            },
            fontSizeLarge: {
                fontSize: "24px"
            }
        }
    }
};

//# sourceMappingURL=SvgIcon.js.map